import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { duplicateTask, moveToTrash } from "~/store/actions/actions.tasks.jsx";
import { getRawConfigOption } from "~/store/selectors/selector.configOptions.jsx";
import { getProjectById } from "~/store/selectors/selector.projects";
import { getTaskById } from "~/store/selectors/selector.tasks.jsx";
import { StartMenuBottomOptions } from "./StartMenuBottomOptions.jsx";

export const StartMenuBottomOptionsContainer = ({
  id,
  projectId,
  onDuplicate,
  onMakeRecurring,
  onMoveToTrash,
  onStartEdit,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const task = useSelector((state) => getTaskById(state, id));
  const project = useSelector((state) => getProjectById(state, projectId));
  const recurringTasksEnabled = useSelector((state) => getRawConfigOption(state, `recurring_tasks_enabled`));

  const handleDuplicate = useCallback(
    ({ name }) => {
      typeof onDuplicate === "function" && onDuplicate();
      dispatch(
        duplicateTask(projectId, id, {
          new_name: name,
          project_id: projectId,
          task_id: id,
        })
      ).then((action) => {
        const { response = {} } = action;
        const { result = {} } = response;

        const { single = 0 } = result;

        if (single > 0) {
          navigate(`/projects/${projectId}/tasks/${single}`);
        }
      });
    },
    [id, projectId, dispatch, onDuplicate, navigate]
  );

  const handleMakeRecurring = useCallback(() => {
    typeof onMakeRecurring === "function" && onMakeRecurring();
  }, [onMakeRecurring]);

  const handleMoveToTrash = useCallback(
    (trashTracking) => {
      typeof onMoveToTrash === "function" && onMoveToTrash();
      dispatch(moveToTrash(id, trashTracking));
    },
    [dispatch, id, onMoveToTrash]
  );

  return (
    <StartMenuBottomOptions
      onMoveToTrash={handleMoveToTrash}
      onDuplicate={handleDuplicate}
      onMakeRecurring={handleMakeRecurring}
      taskName={task?.name}
      taskId={task?.id}
      onEditButtonClick={onStartEdit}
      recurringTasksEnabled={recurringTasksEnabled}
      projectId={project?.id}
    />
  );
};

StartMenuBottomOptionsContainer.propTypes = {
  id: PropTypes.number.isRequired,
  projectId: PropTypes.number.isRequired,
  onDuplicate: PropTypes.func,
  onMakeRecurring: PropTypes.func,
  onMoveToTrash: PropTypes.func,
  onStartEdit: PropTypes.func,
};
